import React from 'react';

import { P } from './paragraph-styled-component';

const Paragraph = props => {
  return <P {...props}>{props.children}</P>;
};

export default Paragraph;
